import type { Metadata } from 'next'

import type { PageAccessError } from './types'

const commonMetadata: Metadata = {
  robots: 'noindex',
}

const PAGE_ACCESS_ERROR_TO_METADATA: Record<PageAccessError, Metadata> = {
  not_enough_permission: {
    title: 'Access Denied',
    description: 'You do not have the permission to access this page.',
  },
  email_not_verified: {
    title: 'Please verify your email',
    description: 'Your email has not been verified yet. Please try again.',
  },
  not_logged_in: {
    title: 'Please sign in to access this page',
    description: 'You need to be logged in to your account to access this page.',
  },
  user_rejected: {
    title: "You're almost there!",
    description: 'It looks like we need more information to approve your Schoolhouse application.',
  },
  onboarding_already_finished: {
    title: 'Access Denied',
    description: 'You have already finished onboarding! Please return to the homepage.',
  },
  onboarding_not_finished: {
    title: 'Almost There',
    description: 'You still need to finish your onboarding.',
  },
  not_enough_age: {
    title: 'You are too young to access this page!',
    description: 'Please come back after you turn 13 years old.',
  },
  user_suspended: {
    title: 'Your account has been suspended',
    description:
      'Unfortunately, your account has been suspended for violating our community guidelines.',
  },
  user_maybe_suspended: {
    title: 'Your account is unavailable',
    description: 'Your account is unavailable at the moment.',
  },
}

// Inject common metadata into all the scenarios
Object.keys(PAGE_ACCESS_ERROR_TO_METADATA).forEach(key => {
  Object.assign(PAGE_ACCESS_ERROR_TO_METADATA[key as PageAccessError], commonMetadata)
})

export { PAGE_ACCESS_ERROR_TO_METADATA }
